"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_CONTROLLER_REDUCERS_ACTIONS = exports.APP_CONTROLLER_REDUCERS = exports.App = exports.configStore = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const redux_1 = require("redux");
const redux_saga_1 = __importDefault(require("redux-saga"));
const react_redux_1 = require("react-redux");
const history_1 = require("history");
const connected_react_router_1 = require("connected-react-router");
const GoogleTagManager_1 = __importDefault(require("./GoogleTagManager"));
const Core_1 = __importDefault(require("./Core"));
/* REDUCERS */
const context_1 = __importDefault(require("./Reducers/context"));
const errorCatcher_1 = __importStar(require("./Reducers/errorCatcher"));
// setting up global vars
window.s = window.s || {};
window.dataLayerGTM = window.dataLayerGTM || [];
// window.flexibility = flexibility;
const configStore = (rootReducers, rootSagas, reduxTools) => {
    const sagaMiddleware = (0, redux_saga_1.default)();
    const history = (0, history_1.createBrowserHistory)();
    let composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
    if (!reduxTools) {
        composeEnhancers = redux_1.compose;
    }
    const preloadedState = window.__PRELOADED_STATE__;
    delete window.__PRELOADED_STATE__;
    const mystore = (0, redux_1.createStore)(rootReducers(history), preloadedState, composeEnhancers((0, redux_1.applyMiddleware)(sagaMiddleware, (0, connected_react_router_1.routerMiddleware)(history))));
    sagaMiddleware.run(rootSagas);
    return {
        store: mystore,
        history,
    };
};
exports.configStore = configStore;
/**
 * App component.
 * @returns {object} App rendered.
 */
const App = ({ projectId, urlLibrary, modulesLibrary, rootReducers, rootSagas, reduxTools, ModalComponent, defaultErrorScreen, gtmId, }) => {
    // it must append modules 500 and 404 on modules and urlLibrary
    const newModulesLibrary = modulesLibrary;
    const module404 = newModulesLibrary.find((module) => module.id === '404');
    const module500 = newModulesLibrary.find((module) => module.id === '500');
    if (!module404) {
        newModulesLibrary.push({
            id: '404',
            loader: react_1.default.lazy(() => Promise.resolve().then(() => __importStar(require('./Screens/NotFound')))),
        });
    }
    if (!module500) {
        newModulesLibrary.push({
            id: '500',
            loader: react_1.default.lazy(() => Promise.resolve().then(() => __importStar(require('./Screens/Error')))),
        });
    }
    const { store, history } = (0, exports.configStore)(rootReducers, rootSagas, reduxTools);
    return (react_1.default.createElement(react_redux_1.Provider, { store: store },
        react_1.default.createElement(connected_react_router_1.ConnectedRouter, { history: history },
            react_1.default.createElement(GoogleTagManager_1.default, { gtmId: gtmId, dataLayerName: "dataLayerGTM" }),
            react_1.default.createElement(Core_1.default, { history: history, projectId: projectId, urlLibrary: urlLibrary, modulesLibrary: newModulesLibrary, defaultErrorScreen: defaultErrorScreen }),
            react_1.default.createElement(ModalComponent, { projectId: projectId }))));
};
exports.App = App;
exports.App.propTypes = {
    ModalComponent: prop_types_1.default.func.isRequired,
    defaultErrorScreen: prop_types_1.default.object,
    reduxTools: prop_types_1.default.bool,
    gtmId: prop_types_1.default.string,
};
exports.App.defaultProps = {
    defaultErrorScreen: null,
    reduxTools: false,
    gtmId: 'GTM-KDQ556C',
};
exports.default = exports.App;
/* REDUCERS */
exports.APP_CONTROLLER_REDUCERS = {
    context: context_1.default,
    errorCatcher: errorCatcher_1.default,
};
exports.APP_CONTROLLER_REDUCERS_ACTIONS = {
    errorCatcherActions: errorCatcher_1.actions,
};
//# sourceMappingURL=index.js.map